import styled from 'styled-components';

import { ActionTableCell } from '@/modules/theme/components/Table/ActionTableCell.styled';

export const ActionTableCellStyled = styled(ActionTableCell)({
  position: 'relative',
});
